<template>
  <div v-show="isLoaded" class="mMaridajeHoney-container" v-observe-visibility="startAnimate">
    <div class="brush-background">
      <h2 class="mSection-title" :class="{animate: animate}">Maridaje</h2>
      <p class="mSection-subtitle" :class="{animate: animate}">Disfruta de los platillos ideales para maridar con Strongbow Honey, abriendo los sentidos a vivir su máximo sabor.</p>
    </div>
    <div class="img-container">
      <img class="img-maridaje" :src="maridaje" alt="Maridaje Honey">
      <div class="stick"></div>
      <div class="point"></div>
    </div>
    <div class="mfeature feature-botana" v-observe-visibility="startAnimate1">
      <div class="yellow-box feature-botana" :class="{animate: animate1}"></div>
      <h3 class="feature-title" :class="{animate: animate1}">Con <br>Botana</h3>
      <ul class="list-feature">
        <p class="paragraph">Todo esto con un toque de miel:</p>
        <li>Pan de hojaldre con queso crema.</li>
        <br>
        <li>Belleria y galletas de harinas ricas o especiadas con untables de mantequillas, quesos o patés.<br></li>
        <br>
        <li>Tartaletas saladas con tomate y romero.</li>
        <br>
        <li>Pan horneado con quesos.</li>
      </ul>
    </div>
    <div class="mfeature feature-quesos" v-observe-visibility="startAnimate2">
      <div class="yellow-box feature-quesos" :class="{animate: animate2}"></div>
      <h3 class="feature-title" :class="{animate: animate2}">Con <br>quesos</h3>
      <ul class="list-feature">
        <li>De cabra o bluecheese con pan tostado y un toque de miel.</li>
      </ul>
    </div>
    <div class="mfeature feature-fuertes" v-observe-visibility="startAnimate3">
      <div class="yellow-box feature-fuertes" :class="{animate: animate3}"></div>
      <h3 class="feature-title" :class="{animate: animate3}">Con platos fuertes</h3>
      <ul class="list-feature">
        <p class="paragraph">Todo esto con un toque de miel:</p>
        <li>Filete de salmón con costra de frutos secos <br>
        (almendra, ajonjolí, etc).</li>
        <li>Carne de puerco con salsas agridulces.</li>
        <li>Albóndigas.</li>
        <li>Tartas o quiches de vegetales.</li>
      </ul>
    </div>
    <div class="mfeature feature-postres" v-observe-visibility="startAnimate4">
      <div class="yellow-box feature-postres" :class="{animate: animate4}"></div>
      <h3 class="feature-title" :class="{animate: animate4}">Con <br>postres</h3>
      <ul class="list-feature">
        <li>Tartas de pera, almendra y miel.</li>
        <br>
        <li>A base de miel y frutos secos (dedos de reina o pasteles con estos ingredientes).</li>
        <br>
        <li>Crepas de almendras, nuez y miel.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import maridaje from "@/assets/honey/1DX_0362.jpg"
import Bowser from "bowser"; 
import { mapGetters } from "vuex";
export default {
  name: "MaridajeHoney",
  components: {},
  data() {
    return {
      animate: false,
      animate1: false,
      animate2: false,
      animate3: false,
      animate4: false,
      maridaje,
      isSafari: false
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    },
    startAnimate1(isVisible) {
      if(isVisible) {
        this.animate1=true
      }
    },
    startAnimate2(isVisible) {
      if(isVisible) {
        this.animate2=true
      }
    },
    startAnimate3(isVisible) {
      if(isVisible){
        this.animate3=true
      }
    },
    startAnimate4(isVisible) {
      if(isVisible) {
        this.animate4=true
      } 
    },
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Honey/MaridajeHoney.scss";
</style>
